import {post} from "@/utils/request";

export default class apiUserFollow {
  static async subscribe(uid){
    return post('/home/user_follow/subscribe', {uid})
  }
}
